import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Select, { components } from "react-select";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
// import { SEARCH_ICON } from "../../../assets/js/image";
import {
  updateServiceData,
  resetServiceData,
} from "../../../redux/serviceSlice";
import { resetCommonSliceData } from "../../../redux/commonSlice";
import { updateHeaderData } from "../../../redux/headerSlice";
import { httpGetAllVendorProfileList,
  httpGetVendorProfileById
 } from "../../../service/httpClient";
import "./GlobalSearch.css";
import { Constants } from "ag-grid-community";
import Cookie from "js-cookie";
import AppContext from "../../../context/appcontext";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.319 14.4326C20.7628 11.2941 20.542 6.75347 17.6569 3.86829C14.5327 0.744098 9.46734 0.744098 6.34315 3.86829C3.21895 6.99249 3.21895 12.0578 6.34315 15.182C9.22833 18.0672 13.769 18.2879 16.9075 15.8442C16.921 15.8595 16.9351 15.8745 16.9497 15.8891L21.1924 20.1317C21.5829 20.5223 22.2161 20.5223 22.6066 20.1317C22.9971 19.7412 22.9971 19.1081 22.6066 18.7175L18.364 14.4749C18.3493 14.4603 18.3343 14.4462 18.319 14.4326ZM16.2426 5.28251C18.5858 7.62565 18.5858 11.4246 16.2426 13.7678C13.8995 16.1109 10.1005 16.1109 7.75736 13.7678C5.41421 11.4246 5.41421 7.62565 7.75736 5.28251C10.1005 2.93936 13.8995 2.93936 16.2426 5.28251Z"
          fill="currentColor"
        />
      </svg>
    </components.DropdownIndicator>
  );
};

const GlobalSearch = ({}) => {
  const context=useContext(AppContext);
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "white",
      borderColor: "#9e9e9e",
      minHeight: "30px",
      height: "30px",
      color: "white !important",
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: "30px",
      padding: "0 6px",
     // background: "#d3d3d352 !important",
    }),

    input: (provided, state) => ({
      ...provided,
      margin: "0px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "30px",
      background: "#6c757d !important",
      padding: "3px !important",
      color: "white !important",
      borderRadius: "0px 4px 4px 0px",
    }),
  };
  const store = useSelector(
    (state) => ({
      vendorList: state.service?.vendorList || [],
      selectedVendor: state.header.selectedVendor,
      fetch: state.header.fetch,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    document.addEventListener("vendorAddedEvent", (e) => getVendorList());
    store.fetch && getVendorList();
    return () => {
      document.removeEventListener("vendorAddedEvent", (e) => getVendorList());
    };
  }, []);

  const getVendorList = async () => {
    let vendorList = [];
    try {
      const response = await httpGetAllVendorProfileList();
      if (response) {
        response.data.map((value) => {
          formatVendorListResponse(value).map((array) => {
            vendorList.push(array);
          });
        });
      }
    } catch (e) {
      console.log("Error fetching all vendor list", e.message);
    } finally {
      dispatch(
        updateServiceData({
          vendorList,
        })
      );
    }
  };

  const formatVendorListResponse = (data) => {
    let searchOptions = [];
    const dunsLabel =
      data.profileType && data.profileType.length > 0
        ? data.duns + " - " + data.profileType
        : data.duns;
    const vendorCorpLabel =
      data.profileType && data.profileType.length > 0
        ? data.vendorCorpName + " - " + data.profileType
        : data.vendorCorpName;
    searchOptions.push({
      value: data.vendorProfileId,
      label: dunsLabel,
    });
    searchOptions.push({
      value: data.vendorProfileId,
      label: vendorCorpLabel,
    });
    return searchOptions;
  };

  const handleChange = (selectedOption) => {
    const selectedVendorId = selectedOption.value;
    dispatch(updateHeaderData({ selectedVendor: selectedOption }));
    dispatch(resetServiceData());
    dispatch(resetCommonSliceData());
    dispatch(updateServiceData({ fetching: true }));
    localStorage.setItem("vid", selectedVendorId);
    const role = context?.roles?.roleName;
    httpGetVendorProfileById(selectedVendorId)
    .then((res)=>{
      if(res.data?.vendorDetail?.merchandiseType==="MP" &&
        res.data?.vendorDetail?.liveDate!==null && role === "sellerCentralAdmin")
        {
        history.push(`/sellerreports/managereports`);
        }
      else
       {
      history.push(`/boarding/vendor/company/${selectedOption.value}`);
       }
  }).catch(error => {
    history.push(`/boarding/vendor/company/${selectedOption.value}`);
  }); 
  };

  return (
    <div className="navbar_vendorSearch">
      <div className="navbar_vendorSearch_searArea">
        <Select
          value={store.selectedVendor}
          onChange={handleChange}
          options={store.vendorList}
          inputId="searchVendors"
          placeholder="Search by duns or company name..."
          closeMenuOnSelect={true}
          components={{ DropdownIndicator }}
          styles={customStyles}
        />
        <input
          type="hidden"
          id="searchVendorsInput"
          defaultValue={store.selectedVendor.value}
        />
      </div>
    </div>
  );
};

export default GlobalSearch;
